import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'ness-find-person-container',
  templateUrl: './find-person-container.component.html',
  styles: [
  ]
})
export class FindPersonContainerComponent {
  @Input() excludePersons: ServerModels.ENESS_PersonDTO[] = [];
  @Input() suppressEdit: boolean = false;
  @Output() notifySelectedPeople: EventEmitter<ServerModels.ENESS_PersonDTO[]> = new EventEmitter<ServerModels.ENESS_PersonDTO[]>();

}
